import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

let refreshing = null;

api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config || {};
    const status = error.response?.status;
    const isAuthRoute = (original.url || "").startsWith("/auth/");
    if (status === 401 && !original._retried && !isAuthRoute) {
      original._retried = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
        await refreshing;
        return api(original);
      } catch (e) {
        window.dispatchEvent(new Event("auth:signed-out"));
      }
    }
    return Promise.reject(error);
  },
);

export function apiError(e, fallback = "Something went wrong. Please try again.") {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => (d && typeof d.msg === "string" ? d.msg.replace(/^Value error, /, "") : JSON.stringify(d))).join(" ");
  if (typeof detail.message === "string") return detail.message;
  return String(detail);
}

export function apiErrorCode(e) {
  const detail = e?.response?.data?.detail;
  return detail && typeof detail === "object" && !Array.isArray(detail) ? detail.code : null;
}
